export const getPersonalDetails = state => state.personalDetailsReducer.details;
export const getPersonalDetailsIsFetching = state => state.personalDetailsReducer.isFetching;
export const getPersonalDetailsError = state => state.personalDetailsReducer.error;
export const getPersonalDetailsPostSuccess = state => state.personalDetailsReducer.postSuccess;
export const getPersonalDetailsIsPosting = state => state.personalDetailsReducer.isPosting;
